import { Box, Text } from 'ink';
import type { TextProps } from 'ink';
import type { KeyDetails, GetCellTextProps, DataItem } from './tableTypes';

/*
  See Table component
*/
export default function TableRow({
  data,
  getCellTextProps = ({ props }) => props,
  keyDetails,
  textProps = {},
}: {
  data: DataItem;
  getCellTextProps?: GetCellTextProps;
  keyDetails: KeyDetails;
  textProps?: TextProps;
}) {
  let topLine = '├';
  topLine += Object.values(keyDetails)
    .map(({ width }) => '─'.repeat(width + 2))
    .join('┼');
  topLine += '┤';

  const content = (
    <>
      <Text>│ </Text>
      {Object.entries(data).map(([key, value], index) => {
        return (
          <Box key={key}>
            {index > 0 ? <Text> │ </Text> : null}
            <Box width={keyDetails[key].width}>
              <Text
                {...getCellTextProps({
                  key,
                  props: textProps,
                  rowData: data,
                  value,
                })}
              >
                {value}
              </Text>
            </Box>
          </Box>
        );
      })}
      <Text> │</Text>
    </>
  );

  return (
    <Box flexDirection="column">
      <Text>{topLine}</Text>
      <Box>{content}</Box>
    </Box>
  );
}
